import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const executeMonthClose = (month, period, data) => apiActionCreator({
  'endpoint': `/month-close/${month}/${period}`,
  'authenticated': true,
  'types': [
    ActionTypes.SUBMIT_EXECUTE_MONTH_CLOSE_REQUEST,
    [
      ActionTypes.SUBMIT_EXECUTE_MONTH_CLOSE_SUCCESS,
      MessageActions.addMessageBoxInfo('Cierre de mes Procesado Correctamente'),
    ],
    [
      ActionTypes.SUBMIT_EXECUTE_MONTH_CLOSE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const fetchMonthCloseReport = ({month, year, area, difference}) => apiActionCreator({
  'endpoint': `/month-close-report/${month}/${year}/${area}/${difference}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_MONTH_CLOSE_REPORT,
    ActionTypes.FETCHED_MONTH_CLOSE_REPORT,
    [
      ActionTypes.FETCHED_MONTH_CLOSE_REPORT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const deleteMonthCloseReport = (data) => ({
  'type': ActionTypes.DELETE_MONTH_CLOSE_REPORT,
});

export const changeMonthReportPage = (value) => ({
  'type': ActionTypes.CHANGE_MONTH_CLOSE_REPORT_LIST_PAGE,
  'payload': value,
});

export const changeMonthReportPageSize = (value) => ({
  'type': ActionTypes.CHANGE_MONTH_CLOSE_REPORT_LIST_PAGE_SIZE,
  'payload': value,
});

export const downloadMonthCloseReportFile = (month, period, area) => apiActionCreator({
  'endpoint': `/month-close-report-excel/${month}/${period}/${area}`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_MONTH_CLOSE_REPORT_LIST_FILE,
    ActionTypes.DOWNLOADED_MONTH_CLOSE_REPORT_LIST_FILE,
    [
      ActionTypes.DOWNLOADED_MONTH_CLOSE_REPORT_LIST_FILE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const deleteUrl = (data) => ({
  'type': ActionTypes.DELETE_URL,
});
